import React from 'react';
import PortfolioTable from './PortfolioTable';
import PortfolioCharts from './PortfolioCharts';

const Portfolio: React.FC = () => {
  return (
    <div className="tab-content active">
      <h2 className="text-2xl font-bold mb-6">Portfolio Übersicht</h2>
      <PortfolioTable />
      <PortfolioCharts />
    </div>
  );
};

export default Portfolio;